import {
  TRADE_LIST_PAGE_LOADED,
  TRADE_LIST_NEXT_PAGE_LOADED,
  TRADE_LIST_PAGE_UNLOADED,
  TRADE_LIST_SEARCH_LOADED,
  UPDATE_FIELD_TRADE_LIST_SEARCHTERM,
  TRADE_DETAIL_PAGE_LOADED,
  TRADE_DETAIL_PAGE_UNLOADED
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
  switch (action.type) {
    case TRADE_LIST_PAGE_LOADED:
    case TRADE_LIST_SEARCH_LOADED:
    case TRADE_LIST_NEXT_PAGE_LOADED:
      return {
        ...state,
        orders: action.payload.orders,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
      }
    case TRADE_LIST_PAGE_UNLOADED:
    case TRADE_DETAIL_PAGE_UNLOADED:
      return {}
    case UPDATE_FIELD_TRADE_LIST_SEARCHTERM:
      return {
        ...state,
        [action.key]: action.value,
      }
    case TRADE_DETAIL_PAGE_LOADED:
      return {
        ...state,
        order: action.payload ? action.payload.order : null
      }
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/trade.js